import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { SpaceModel } from "../interfaces/Space";
import Map from "../components/Map";
import SearchBar from "./bars/SearchBar";
import RouteList from "./RouteList";
import UseRoute from "../hooks/UseRoute";
import "../styles/layouts/mapcontainer.scss";
import InfoBar from "./bars/InfoBar";
import UseSwipe from "../hooks/UseSwipe";
import { OrientationContext } from "../contexts/OrientationContext";

type Props = {
  spaceList: SpaceModel[]
  mapFilters: any
  hidden: boolean
  mapTitleClicked: number
}

export default function MapContainer({ spaceList, mapFilters, hidden, mapTitleClicked }: Props) {

  const swipeProps = UseSwipe({ speedThreshold: 2, action: () => setInfoBarOpen(false) });

  //scrolling
  const barContainerRef = useRef(null);

  const internalSpaceList = useRef<SpaceModel[]>()
  const [pickedSpace, setPickedSpace] = useState<SpaceModel | undefined>();
  const [routeMode, setRouteMode] = useState<boolean>(false);
  const routeModeRef = useRef(false);
  const [mapClicked, setMapClicked] = useState<number>(0);
  const [isSpacePicked, setIsSpacePicked] = useState(false);

  const isLandscapeMode = useContext(OrientationContext)
  useEffect(() => {
    if (isLandscapeMode) {
      setInfoBarOpen(false);
    }
  }, [isLandscapeMode])

  const [infoBarOpen, setInfoBarOpen] = useState<boolean>(false);
  const onClickExpand = useCallback((force: boolean | undefined) => {
    if (isLandscapeMode) return;
    setInfoBarOpen(ibo => {
      if (typeof force !== 'undefined') {
        return force;
      }
      return !ibo;
    });
  }, [isLandscapeMode])

  const [searchList, setSearchList] = useState<SpaceModel[]>(spaceList);

  //Route
  const { route, subtractedList, clearRoute, addSpace, removeSpace, setRoute, toggleSpace } = UseRoute({ spaceList });

  useEffect(() => {
    clearRoute();
    setRouteMode(false);
  }, [mapFilters])

  const setPicked = useCallback((space: SpaceModel | undefined) => {
    if (!space) return;

    if (routeModeRef.current) {
      toggleSpace(space)
    } else {
      setPickedSpace(space);
    }

  }, [toggleSpace])

  //listen to map click on navbar
  useEffect(() => {
    setInfoBarOpen(false);
  }, [mapTitleClicked])

  useEffect(() => {
    internalSpaceList.current = [...spaceList];

    // setTimeout(() => {
    //   //TODO: REMOVE
    //   const res = internalSpaceList.current!.filter((sm) => {
    //     return sm.properties.name === "Painel";
    //   })[0];
    //   setTimeout(() => {
    //     setPicked(res);
    //     setInfoBarOpen(true);
    //   }, 1000)
    // }, 500)
  }, [setPicked, spaceList])

  //when space changes, reset infobar to closed
  useEffect(() => {
    setInfoBarOpen(false);
  }, [pickedSpace])

  const doReset = useCallback(() => {
    setMapClicked(Date.now());
    setRouteMode(false);
    setIsSpacePicked(false);
    setPickedSpace(undefined);
  }, [])




  const setPickedById = useCallback((id: string) => {
    if (!id) {
      setPicked(undefined);
    }

    if (internalSpaceList?.current?.length) {
      const pckSpace = internalSpaceList!.current!.find(spc => spc.id === id);
      if (!pckSpace) return;

      setPicked(pckSpace);
    }
  }, [setPicked, internalSpaceList])

  useEffect(() => {
    routeModeRef.current = routeMode;
    if (!routeMode) {
      setSearchList(spaceList);
      doReset();
    } else {
      setSearchList(subtractedList);
    }
  }, [clearRoute, routeMode, doReset, spaceList, subtractedList])

  return <div className="map-container">
    <div
      {...swipeProps}
      ref={barContainerRef} className="bar-container">
      <SearchBar
        spaceList={searchList}
        mapClicked={mapClicked}
        setPickedSpace={setPicked}
        pickedSpace={pickedSpace}
        isPicked={true} routeMode={routeMode}
        isSpacePicked={isSpacePicked}
        onClickAction={onClickExpand}
        actionStatus={infoBarOpen} />

      {routeMode && (
        <RouteList
          startingSpace={pickedSpace}
          route={route}
          addSpace={addSpace}
          removeSpace={removeSpace}
          setRoute={setRoute}
          clearRoute={clearRoute}
        />
      )}

      {infoBarOpen && <InfoBar space={pickedSpace} open={infoBarOpen} />}
    </div>

    <Map setPickedById={setPickedById}
      pickedSpace={pickedSpace}
      route={route}
      routeMode={routeMode}
      setRouteMode={setRouteMode}
      spaces={spaceList}
      mapFilters={mapFilters}
      hidden={!hidden || infoBarOpen}
      setMapClicked={setMapClicked}
      setIsSpacePicked={setIsSpacePicked}
      mapTitleClicked={mapTitleClicked} />
  </div>;
}
